<template>
    <div class="has-text-centered">
        <div class="app-block p-md">
            <div>
                <span>{{ $t('candidate.fees.bank_check.1') }} {{ school.application_fees }} {{ school.fees_currency }} {{ $t('candidate.fees.bank_check.2') }}
                    <a :href="'/candidature/bordereau/' + application.id" :title="$t('candidate.fees.bank_check.3')">{{ $t('candidate.fees.bank_check.4') }}</a>
                    {{ $t('candidate.fees.bank_check.5') }} :</span>
            </div>
            <div class="p-md">
                <div class="p-md">
                    <a :href="'/candidature/bordereau/' + application.id" :title="$t('candidate.fees.bank_check.3')"><i
                            class="fa fa-file-pdf-o fa-3x" aria-hidden="true"></i></a>
                </div>
            </div>
            <br>
            <strong>Siège social Diderot Education</strong>
            <br>Service National des Inscriptions
          <br>8 rue Hautefeuille
          <br>75006 Paris
            <br>France

            <hr>
            <div class="has-text-centered">
                <transition name="slide-fade">
                    <div class="has-text-danger">{{ errorMsg }}</div>
                </transition>
                <button :class="'button-valid button ' + isLoading" @click="send">{{ $t('candidate.fees.bank_check.button') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import services from 'services/candidate'

    export default {
        data () {
            return {
                isLoading: '',
                errorMsg: ''
            }
        },
        props: {
            school: { type: Object },
            candidate: { type: Object }
        },
        computed: {
            ...mapGetters({
                status: 'candidate/getStatus'
            }),
            application () {
                return this.candidate.applications
            },
        },
        methods: {
            ...mapActions({
                setPayment: 'candidate/savePaymentMode'
            }),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            fetchCheckStub () {
                this.toggleLoading()
                services.fetchCheckStub(this.application.id)
                    .then((response) => {
                        const headers = response.headers;
                        const blob = new Blob([ response.data ], { type: headers[ 'content-type' ] })
                        const link = document.createElement('a')
                        const header = response.headers[ 'content-disposition' ]
                        const filename = header.match(/filename="(.+)"/)[ 1 ]
                        link.href = window.URL.createObjectURL(blob)
                        link.download = filename
                        link.click();
                        this.toggleLoading()
                        this.loading = 'is-disabled'
                        this.visible = false
                    }).catch((err) => {
                    this.error = err
                    this.toggleLoading()
                })
            },
            send: function () {
                const payment = {}
                payment.app_id = this.application.id
                payment.mode = 'BANK-CHECK'
                this.toggleLoading()
                this.setPayment(payment).then((result) => {
                    if (this.status === 200) {
                        this.toggleLoading()
                        this.application.payment_mode = 'BANK-CHECK'
                        this.application.fees_complete = 1
                        this.$emit('send')
                    } else if (this.status === 403) {
                        this.toggleLoading()
                        this.$emit('notAuthenticated')
                    } else {
                        this.toggleLoading()
                        this.errorMsg = this.$t('candidate.general.unknown')
                    }
                }).catch((err) => {
                    this.toggleLoading()
                    this.errorMsg = this.$t('candidate.general.unknown')
                })
            }
        }

    }
</script>
